import { Dayjs } from 'dayjs';

export enum TimePeriod {
  WEEK = 'WEEK',
  MONTH = 'MONTH',
  QUARTER = 'QUARTER',
  YTD = 'YTD',
  TWO_YEARS = 'TWO_YEARS',
  YEAR = 'YEAR',
  CUSTOM = 'CUSTOM',
  CYCLE = 'CYCLE',
}

export interface Period {
  beginn: Dayjs;
  end: Dayjs;
  period: TimePeriod;
}
